import { PipFace } from '../../ui/icons.js';
import type { FeatureManifest } from '../registry.js';

/**
 * SCR-17 profile and costumes (MT-09, with MT-05 level and SY-01 save state): Pip in the
 * costume and look he wears, the shop name, player level and stats, and the wardrobe (outfits
 * and looks: wear, buy with gems, try on). No flag of its own: the profile is core; the owned
 * lists come from GET /v1/costumes (the `collections` kill switch) and GET /v1/skins, and fall
 * back to the store catalog when those are off.
 */
export default {
  id: 'costumes',
  online: true,
  art: ['pip_extra'],
  provides: ['profile'],
  entry: { order: 30, icon: PipFace, label: 'feature.costumes.rail', testId: 'rail-profile', open: 'profile' },
  load: () => import('./index.js'),
} satisfies FeatureManifest;
